import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {convertPipeToBrTag} from "../../utils";
import ModalWindow from "../../components/modal-window";

/**
 *  EquipmentItem
 */
class EquipmentItem extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    title: PropTypes.string,
    itemImageSrc: PropTypes.string,
    detailLinkLabel: PropTypes.string,
    detail: PropTypes.string,
    mbDetail: PropTypes.string,
    openModalWindow: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    title: null,
    itemImageSrc: null,
    detailLinkLabel: null,
    detail: null,
    mbDetail: null,
    openModalWindow: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {};
  }
  
  render() {
  
    // 画像
    const renderImage = ()=> {
      if (this.props.itemImageSrc && this.props.itemImageSrc !== '') {
        return (
          <img className="EquipmentItem__image" src={this.props.itemImageSrc}/>
        )
      } else {
        return null;
      }
    };
    
    // タイトル
    const renderTitle = ()=> {
      if (this.props.title && this.props.title !== '') {
        return (
          <h4 className="EquipmentItem__heading"
              dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.props.title)}}/>
        )
      } else {
        return null;
      }
    };
  
    // 詳細
    const renderDetail = () => {
      const getDetailPc = () => {
        if (this.props.detail && this.props.detail !== '') {
          return this.props.detail;
        } else {
          return null;
        }
      };
      const getDetailMb = () => {
        if (this.props.mbDetail && this.props.mbDetail !== '') {
          return this.props.mbDetail;
        } else {
          return getDetailPc();
        }
      };
      const detail = getDetailPc();
      const detailMb = getDetailMb();
      if (detail && detailMb) {
        return (
          <div className="EquipmentItem__detail">
            <a className="EquipmentItem__detail__link"
               href="javascript:void(0);"
               onClick={(e) => {
                 e.preventDefault();
                 if (this.props.openModalWindow !== null) {
                   this.props.openModalWindow({
                     detail: detail,
                     detailMb: detailMb,
                   });
                 }
               }}
            >
              {(this.props.detailLinkLabel && this.props.detailLinkLabel !== '') ? this.props.detailLinkLabel: null}
            </a>
          </div>
        )
      } else {
        return (
          null
        )
      }
    };
    
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <article className="EquipmentItem">
          {renderImage()}
          {renderTitle()}
          {renderDetail()}
        </article>
      </Wrapper>
    )
  }
  
}

export default EquipmentItem;




// WEBPACK FOOTER //
// ./src/containers/equipment-item/index.jsx